import styled from '@emotion/styled';
import { NakedButton } from 'roo-ui/components';
import 'styled-system';
import {
  bottom,
  BottomProps,
  height,
  left,
  LeftProps,
  position,
  PositionProps,
  right,
  RightProps,
  top,
  TopProps,
  width,
} from 'styled-system';

export const PositionedButton = styled(NakedButton)<PositionProps & TopProps & LeftProps & RightProps & BottomProps>`
  ${position}
  ${top}
  ${left}
  ${bottom}
  ${right}
  ${width}
  ${height}
`;
